import React, { useMemo } from 'react';
import { Centered, StaticJoyLogoLoader } from '@apps/createWedding/routes/TyingTheKnot/TyingTheKnot.styles';
import { useTranslation } from '@shared/core';
import { useTyingTheKnotController } from '@apps/createWedding/routes/TyingTheKnot/TyingTheKnot.controller';
import { SpacingStack, TextV2 } from '@withjoy/joykit';
import { wrapWithTyingTheKnotHealthProvider } from './TyingTheKnot.health';
import { JoyLogo } from '@apps/createWedding/components/JoyLogo';
import { HelpCenterLink } from '@apps/createWedding/routes/TyingTheKnot/components/HelpCenterLink';

enum TyingTheKnotComponentState {
  GENERAL_ERROR = 'generalError',
  RATE_LIMIT_ERROR = 'rateLimitError',
  LOADING = 'loading'
}

export const TyingTheKnot = wrapWithTyingTheKnotHealthProvider(() => {
  const { t, t2 } = useTranslation('createWedding');
  const { error } = useTyingTheKnotController();
  const generalError = t('tyingTheKnot').errorText({ HelpCenter: HelpCenterLink });
  const rateLimitError = t('tyingTheKnot').rateLimitErrorText({ HelpCenter: HelpCenterLink });

  const componentState = useMemo<TyingTheKnotComponentState>(() => {
    if (error?.graphQLErrors[0]?.extensions?.props.statusCode === 429) {
      return TyingTheKnotComponentState.RATE_LIMIT_ERROR;
    }

    if (error) {
      return TyingTheKnotComponentState.GENERAL_ERROR;
    }

    return TyingTheKnotComponentState.LOADING;
  }, [error]);

  return (
    <Centered>
      <SpacingStack spacing={8} paddingX={7}>
        {componentState === 'loading' && (
          <>
            <StaticJoyLogoLoader loaderKey="tying-the-knot" />
            <TextV2 textAlign="center" typographyVariant="hed3">
              {t2('tyingTheKnot', 'loadingText')}
            </TextV2>
          </>
        )}
        {componentState === 'generalError' && (
          <>
            <JoyLogo />
            <TextV2 textAlign="center" typographyVariant="hed3" maxWidth={'360px'}>
              {generalError}
            </TextV2>
          </>
        )}
        {componentState === 'rateLimitError' && (
          <>
            <JoyLogo />
            <TextV2 textAlign="center" typographyVariant="hed3" maxWidth={'360px'}>
              {rateLimitError}
            </TextV2>
          </>
        )}
      </SpacingStack>
    </Centered>
  );
});
